export const mapLeadsTimeline = (data) => {
  return {
    points: data.map(({time}) => time),
    leads: data.map(({leads_count}) => leads_count),
    leads_with_optins: data.map(({structural_opt_in_leads_count}) => structural_opt_in_leads_count),
  };
};
